import { createSlice } from '@reduxjs/toolkit';
import { getReportDataById } from '../../../rtk-apis/reports/getReportDataById';

const initialState = {
  status: '',
  data: '',
  msg: '',
  loading: false,
};

const getReportDataByIdSlice = createSlice({
  name: 'getReportDataByIdSlice',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.data = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getReportDataById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getReportDataById.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.data = action?.payload;
        state.msg = action?.payload?.msg;
      })
      .addCase(getReportDataById.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.data = (action?.payload as string) || 'Something went wrong';
      });
  },
});

export const { clearState } = getReportDataByIdSlice.actions;
export default getReportDataByIdSlice.reducer;
